export const BANK_LINKING_SESSION_STORAGE_KEY = "bank_linking_session";

export type BankLinkingSession = {
	session_id: string;
};

export function saveBankLinkingSessionToStorage(session_id: number): void {
	window.localStorage.setItem(
		BANK_LINKING_SESSION_STORAGE_KEY,
		session_id.toString(),
	);
}

export function getBankLinkingSessionFromStorage(): BankLinkingSession | null {
	try {
		const raw = window.localStorage.getItem(BANK_LINKING_SESSION_STORAGE_KEY);
		if (!raw) {
			return null;
		}

		return {
			session_id: raw,
		};
	} catch {
		return null;
	}
}

export function clearBankLinkingSessionFromStorage() {
	if (typeof window === "undefined") {
		return;
	}

	try {
		window.localStorage.removeItem(BANK_LINKING_SESSION_STORAGE_KEY);
	} catch {
		// ignore
	}
}
